import React from 'react';
import { Row, Col, Image, Typography, Button, Tooltip, message, Dropdown, Menu } from 'antd';
import { DownOutlined, FilePdfOutlined, MailTwoTone, PhoneTwoTone } from '@ant-design/icons';
import { fileDetailsFromURL, phoneMask, moneyMask } from 'src/common/utils';
import * as dayjs from 'dayjs';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import { IoCheckmarkSharp, IoCheckmarkDoneSharp, IoCloseSharp, IoChevronDown, IoTrash, IoTrashOutline, IoArrowRedoOutline } from "react-icons/io5";
import { FaRegClock } from "react-icons/fa";
import { uniqueId } from 'lodash';
import axios from 'axios';
import { PRIVATE_STORAGE_API } from 'src/common/constants';

export const ChatMessageQuoted = (props) => {
    const { Text } = Typography
    const { style, message, user, company, onRevokeMessage, ...viewProps } = props;
    const [visible, setVisible] = React.useState(false);
    const [contentUrl, setContentURL] = React.useState(message.content);
    React.useEffect(()=>{
        const proxyFile = async (url) => {
            let token = localStorage.getItem("auth_token")
            let res = await axios.get(`${message?.content}`, { 
                headers: {'Authorization': `Bearer ${token}` },
            })
            setContentURL(res.data?.url)
        }
        if(message?.content?.indexOf(PRIVATE_STORAGE_API) !== -1){
            proxyFile(message.content);
        }else{
            setContentURL(message.content);
        }
    },[message?.content]);

    const renderUser = () => {
        return (
            <Text className="message-author">
            {user?.name}
            </Text>
        );
    }
    const renderProfile = ()=> (
        <Text className="message-author">
          {message.chatbot_uuid ? "Bot" : props.contact?.name}
        </Text>
    );
  
    function replaceAll(str, find, replace) {
        return str.replace(new RegExp(find, 'g'), replace);
    }
    
    const renderText = () => {
        let texts = [<Text key={uniqueId()}>{message.content}</Text>]
        return (
            <Text key={uniqueId()}>
                {texts}
            </Text>
        );
    }
    const renderDeletedMessage = () => {
        return (
        <>
            {message.content_type === "text" && 
                <Tooltip title={ message.status === 3 ? "Mensagem apagada.": dayjs(message.received_at).format("HH:mm")} placement={"bottomRight"}>
                    <Text><del>{message.content}</del></Text>
                </Tooltip>
            }
            {message.content_type !== "text" && 
                <Tooltip title={ message.status === 3 ? "Mensagem apagada.": dayjs(message.received_at).format("HH:mm")} placement={"bottomRight"}>
                    <Text>Essa mensagem foi apagada.</Text>
                </Tooltip>
            }
        </>
        );
    }
    function downloadURI(uri, name) {
        fetch(uri).then(response => response.blob())
        .then(blob => {
            const link = document.createElement("a");
            link.target = "_blank";
            link.href = URL.createObjectURL(blob);
            link.download = name;
            link.click();
        })
        .catch(console.error);
    }
    const renderDocument = () => {
        const { filename } = fileDetailsFromURL(contentUrl)
        return (
            <>
                <Text className="document-attachment">Enviou um documento</Text>
                <Button type="primary" className="document-attachment" icon={<FilePdfOutlined />} size={"small"} onClick={()=> downloadURI(contentUrl, filename)}>
                    Download
                </Button>
            </>
        );
    }
    const renderAudio = () => {
        return (
            <audio controls src={contentUrl}> </audio>
        );
    }
    const renderVideo = () => {
        return (
            <video className="message-video" controls src={contentUrl}> </video>
        );
    }
    const renderStory = (type) => {
        let url = new URL(message.content)
        let mime = url.searchParams?.get("story_type") || "not_available"
        return (
        <>
            <Col>
                <Row wrap>
                    {mime.includes("image") && 
                        <Image 
                            preview={visible} 
                            width={200} 
                            fallback={"https://storage.4bytes.com.br/public-uploads/image-error-fallback.png"}
                            src={message.content} onClick={() => setVisible(true)}
                        />
                    }
                    {mime.includes("video") && 
                        <video className="message-video" controls src={message.content}> </video>
                    }
                </Row>
                <Row>
                    <Text style={{marginTop: 10, marginBottom: 2}}>{ mime.includes("not_available") ? "Esse story não está mais disponível": "Você foi mencionado em um story."}</Text>
                </Row>
            </Col>
        </>
        );
    }

    const renderImage = () => {
        return (
            <Image 
                preview={visible} 
                width={'100%'}
                fallback={"https://storage.4bytes.com.br/public-uploads/image-error-fallback.png"}
                src={contentUrl} 
                onClick={() => setVisible(true)}
            />
        );
    }
    const renderLocation = () => {
        const [latitude, longitude, description] = message.content.split("||")
        return (
            <MapContainer className="map-content" center={[latitude, longitude]} zoom={13} scrollWheelZoom={false}>
                <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={[latitude, longitude]}>
                    <Popup>
                        {description}
                    </Popup>
                </Marker>
            </MapContainer>
        );
    }
 
    let classes = ['message-balloon-container','quoted-message-balloon']
    return (
        <Col {...viewProps} className={classes.join(" ")}>
            <span className='quoted-message'>
                <Row style={{...style, minHeight: '16px', marginLeft: 16}} justify="space-between">
                    {!message.user_id && renderProfile()}
                    {message.user_id && renderUser()}
                </Row>
                <Row className="quoted-message-text">
                    {message.status !== 3 && message.content_type === 'text' && renderText()}
                    {message.status !== 3 && message.content_type === 'image' && <div className='message-media'>{renderImage()}</div>}
                    {message.status !== 3 && message.content_type === 'document' && renderDocument()}
                    {message.status !== 3 && message.content_type === 'audio' && renderAudio()}
                    {message.status !== 3 && message.content_type === 'ptt' && renderAudio()}
                    {message.status !== 3 && message.content_type === 'video' && renderVideo()}
                    {message.status !== 3 && message.content_type === 'location' && renderLocation()}
                    {message.status !== 3 && message.content_type === 'story_mention' && renderStory()}
                    {message.status === 3  && renderDeletedMessage()}
                </Row>
            </span>
        </Col>
    );
};